module.exports = __webpack_public_path__ + "static/media/ninjaface.8210a7d9.png";